export const cdnHost = 'https://cdn.rockalingua.com' as const;

export const staticCdnHost = `${cdnHost}/production/static` as const;
